import { render, staticRenderFns } from "./AudienceAdminDashboard.vue?vue&type=template&id=0f7955b2&"
import script from "./AudienceAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./AudienceAdminDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports